import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@components/Icon';
import { SavedViewsNavSectionController, useIsSavedViewActive } from '@features/saved-views';
import clsx from 'clsx';

import Nav from '../routes';

import type { MenuNavigation } from './menu';

const variantClasses = {
  desktop: { link: 'text-sm font-medium', icon: 'mr-3 h-6 w-6 shrink-0 pt-0.5' },
  mobile: { link: 'text-base font-medium capitalize', icon: 'mr-4 h-6 w-6 shrink-0' },
};

interface MenuNavItemsProps {
  navigation: MenuNavigation[];
  isActive: (path: Nav) => boolean;
  variant: keyof typeof variantClasses;
}

export const MenuNavItems = ({ navigation, isActive, variant }: MenuNavItemsProps) => {
  const isSavedViewActive = useIsSavedViewActive();
  const classes = variantClasses[variant];

  return (
    <>
      {navigation.map((item) => {
        const itemActive = isActive(item.path) && !(item.path === Nav.Submissions && isSavedViewActive);
        return (
          <Fragment key={item.path}>
            <Link
              to={item.path}
              aria-current={itemActive ? 'page' : undefined}
              className={clsx(
                itemActive ? 'bg-info-900 text-white' : 'text-info-300 hover:bg-info-700 hover:text-white',
                'group flex items-center rounded-md px-2 py-2',
                classes.link,
              )}
            >
              <div
                className={clsx(itemActive ? 'text-info-300' : 'text-info-400 group-hover:text-info-300', classes.icon)}
              >
                <Icon name={item.icon} />
              </div>
              {item.name}
            </Link>
            {item.path === Nav.Submissions && <SavedViewsNavSectionController />}
          </Fragment>
        );
      })}
    </>
  );
};
